<template>
  <div>
    <div class="filling-goods-bottom" v-if="!ewmType">
      <van-button type="warning" class="bottom-button" @click="go_index()">回首页</van-button>
      <van-button v-if="type == 'true'" type="info" class="bottom-button" @click="fillingGoods()">装箱</van-button>
      <van-button v-if="type == 'false'" type="default" class="bottom-button" @click="already()"
        style="background-color: darkgray">装箱</van-button>
      <van-button v-if="type == 'false'" type="info" class="bottom-button" @click="revocation()">撤销装箱</van-button>
      <van-button v-if="type == 'true'" type="default" class="bottom-button"
        style="background-color: darkgray">撤销装箱</van-button>
      <van-button type="warning" class="bottom-button" style="margin: 0" @click="getShow">更多</van-button>
      <van-button type="warning" id="add" class="bottom-button" style="width: 40px; margin: 0px 0px 0px 1px"
        @click="getAdd">
        <span style="font-size: 25px">+</span>
      </van-button>
      <van-popup v-model="moreshows" position="bottom">
        <div class="more-class">
          <van-icon name="scan" size="1rem" @click="gourl('fillingGoods')" />
        </div>
        <!-- <div class="more-class" style="padding: 10px 0">
          <span style="font-size: 20px" @click="all_delete()">整单删除</span>
        </div>
        <div class="more-class" style="padding: 10px o;">
          <span style="font-size: 20px;" @click="enforcement()">{{ title }}</span>
        </div> -->
        <div class="more-class">
          <span style="font-size: 20px" v-if="mather_id.length !== 0" @click="create_fillingGoods()">创建母件装箱单</span>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import { get } from "../utils/request";
import { debounce, throttle } from "../common/unti";
import { P } from "core-js/modules/_export";
export default {
  name: "bottom_nav_bar",
  data() {
    return {
      username: "",
      moreshows: this.moreshow,
      title: "强制完成上游订单"
    };
  },
  props: {
    moreShow: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    ewmType: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "",
    },

    fillingGoodsType: {
      type: Boolean,
      default: false,
    },
    revocationType: {
      type: Boolean,
      default: false,
    },
    number: {
      type: String,
      default: false
    },
    newDataId: {
      type: Array,
      default() {
        return [];
      },
    },
    mather_id: {
      type: Number | String,
      default() {
        return "";
      },
    },
  },
  mounted() {
    this.username = window.localStorage.getItem("userinfo");
  },
  methods: {
    enforcement() {
      Dialog.confirm({
        message: "",
        confirmButtonText: "取消",
        cancelButtonText: "确定"
      }).then().catch(async () => {
        if (this.number.length <= 0) {
          Toast('请输入装箱号编号')
          return
        }
        if (this.title == '强制完成上游订单') {
          let data = await this.get(this.APIOBJ.packAfter, { pack_num: this.number })
          Toast(data.msg)
          this.title = '取消强制完成'
        } else {
          let data = await this.get(this.APIOBJ.packnoAfter, { pack_num: this.number })
          Toast(data.msg)
          this.title = '强制完成上游订单'
        }
      })
    },
    create_fillingGoods() {
      this.$store.commit("getFGid", "");
      this.$store.commit("getNumber", "");
      this.$emit("create_fillingGoods", this.mather_id);
      this.moreshows = false;
    },
    getBoolean(data, boolean) {
      data = boolean;
    },
    all_delete() {
      let userinfo = localStorage.getItem('userinfo')
      if (userinfo.length < 1) {
        return
      }
      //整单删除
      if (this.$store.state.type === "false" || this.$store.state.FGid === "") {
        Toast("先撤销再删除 ");
        return;
      }
      Dialog.confirm({
        message: "确定要删除当前装箱单吗？",
      }).then(async () => {
        let packing = await this.get(this.APIOBJ.packingDel, {
          id: this.$store.state.FGid,
        });
        Toast("已删除 ");
        setTimeout(() => {
          this.$router.push("/FGlist?id=&FGid=&number=");
        }, 500);
      });
    },
    gourl(url) {
      url = "http://www.lcyjfz.com/home/scan?url=" + url;
      window.location.href = url;
    },
    getShow() {
      this.moreshows = true;
    },
    go_index() {
      //回到首页
      Dialog.confirm({
        message: "确定要回首页吗？",
      })
        .then(() => {
          this.$router.push("/home");
        })
        .catch(() => {
          // on cancel
        });
    },

    getAdd() {
      //跳转到装箱单
      Dialog.confirm({
        message: "是否放弃当前装箱单",
      })
        .then(() => {
          this.$emit("getAdd"); //发射事件  去改变父组件的值
          this.$router.push({ path: this.$route.path + "?id=&FGid=&number=" });
        })
        .catch(() => {
          // no cancel
        });
    },
    already(){
      Dialog.confirm({
        message: "您已经装箱，请勿重复装箱！",        
        showCancelButton: false, 
        showConfirmButton: true,
      })
    },
    async fillingGoods() {
      //装箱
      let userinfo = localStorage.getItem('userinfo')
      if (userinfo.length < 1) {
        return
      }
      if (!this.$store.state.isHttp) {
        //判断是否进行网络请求
        return;
      }
      this.$store.commit("getisHttp", false); //当请求一次就不再去请求了
      if (!this.fillingGoodsType) {
        return;
      }
      this.getBoolean(this.fillingGoodsType, false);
      if (this.data.length === 0) {
        return;
      }
      // 进行装箱前的判断 => 明细码是否进行装过
      let gids = this.data.map((item) => item.gidNum);//gck_number
      let pids = this.data.map((item) => item.pid);
      let flags = await this.get(this.APIOBJ.checkdoPacking, {
        gid: gids.join(","),
        pid: pids.join(","),
      });
      if (flags.data.msg.indexOf("检查通过") === -1) {
        Dialog.confirm({ title: "装箱单", message: flags.data.msg })
          .then(async () => {
            let packing;
            if (this.$store.state.FGid === "") {
              let data = {
                // number: "",
                // name: "",
                supplier_xh: "",
                // goods_normtype: "",
                goods_count: "",
                gid: this.newDataId.join(",") + ",",
                username: this.username,
                mather_id: this.mather_id.toString(),
              };
              this.data.map((i) => {
                // data.number += (i.goods_number || i.number) + ",";
                // data.name += (i.goods_name || i.name) + ",";
                data.supplier_xh += i.supplier_xh + ",";
                // data.goods_normtype += (i.goods_normtype || i.size) + "|";
                data.goods_count += i.goods_count + ",";
                data.username += ",";
              });
              data.mather_id += ",";
              for (let i in data) {
                data[i] = data[i].substring(0, data[i].length - 1);
              }
              packing = await this.post(this.APIOBJ.doPacking, data);
              if (packing.data.status === 0) {
                Toast(packing.data.msg);
                return;
              }
              this.$store.commit("getNumber", packing.data.data.packing_num);
              this.$store.commit("getFGid", packing.data.data.id);
            } else {
              let data = {
                // number: "",
                // name: "",
                supplier_xh: "",
                // goods_normtype: "",
                goods_count: "",
                id: "",
                gid: "",
                username: this.username,
                mather_id: this.mather_id.toString(),
              };
              this.data.map((i) => {
                // data.number += (i.goods_number || i.number) + ",";
                // data.name += (i.goods_name || i.name) + ",";
                data.supplier_xh += i.supplier_xh + ",";
                // data.goods_normtype += (i.goods_normtype || i.size) + "|";
                data.goods_count += i.goods_count + ",";
                data.gid += i.gck_number + ",";
                data.username += ",";
              });
              data.mather_id += ",";
              for (let i in data) {
                data[i] = data[i].substring(0, data[i].length - 1);
              }
              data["id"] = this.$store.state.FGid;
              // packing = await this.post(this.APIOBJ.packingEdit, data);
              // if (packing.data.status === 0) {
              //   Toast(packing.data.msg);
              //   return;
              // }
              // this.$store.commit("getNumber", packing.data.data.packing_num);
            }

            Toast("装箱" + packing.data.msg);

            this.$store.commit("getType", "false");
            this.getBoolean(this.fillingGoodsType, true);
            this.$emit("fillingGoods", packing.data.data.id);
          })
          .catch(() => {
            this.$store.commit("getisHttp", true); // 取消时 请求就不成立 就需要将请求转换为可以再次请求
          });
      } else {
        let packing;
        if (this.$store.state.FGid === "") {
          let data = {
            // number: "",
            // name: "",
            supplier_xh: "",
            // goods_normtype: "",
            goods_count: "",
            gid: this.newDataId.join(",") + ",",
            username: this.username,
            mather_id: this.mather_id.toString(),
          };
          this.data.map((i) => {
            // data.number += (i.goods_number || i.number) + ",";
            // data.name += (i.goods_name || i.name) + ",";
            data.supplier_xh += i.supplier_xh + ",";
            // data.goods_normtype += (i.goods_normtype || i.size) + "|";
            data.goods_count += i.goods_count + ",";
            data.username += ",";
          });
          data.mather_id += ",";
          for (let i in data) {
            data[i] = data[i].substring(0, data[i].length - 1);
          }
          packing = await this.post(this.APIOBJ.doPacking, data);
          if (packing.data.status === 0) {
            Toast(packing.data.msg);
            return;
          }
          this.$store.commit("getNumber", packing.data.data.packing_num);
          this.$store.commit("getFGid", packing.data.data.id);
        } else {
          let data = {
            // number: "",
            // name: "",
            supplier_xh: "",
            // goods_normtype: "",
            goods_count: "",
            id: "",
            gid: "",
            username: this.username,
            mather_id: this.mather_id.toString(),
          };
          this.data.map((i) => {
            // data.number += (i.goods_number || i.number) + ",";
            // data.name += (i.goods_name || i.name) + ",";
            data.supplier_xh += i.supplier_xh + ",";
            // data.goods_normtype += (i.goods_normtype || i.size) + "|";
            data.goods_count += i.goods_count + ",";
            data.gid += i.gck_number + ",";
            data.username += ",";
          });
          data.mather_id += ",";
          for (let i in data) {
            data[i] = data[i].substring(0, data[i].length - 1);
          }
          data["id"] = this.$store.state.FGid;
          // packing = await this.post(this.APIOBJ.packingEdit, data);
          // if (packing.data.status === 0) {
          //   Toast(packing.data.msg);
          //   return;
          // }
          // this.$store.commit("getNumber", packing.data.data.packing_num);
        }

        Toast("装箱" + packing.data.msg);

        this.$store.commit("getType", "false");
        this.getBoolean(this.fillingGoodsType, true);
        this.$emit("fillingGoods", packing.data.data.id);
      }
    },
    async revocation() {
      //撤销装箱
      Dialog.confirm({ message: '撤销装箱单会导致整箱删除，确定要删除装箱单吗' })
        .then(async () => {
          if (!this.revocationType) {
            return;
          }
          let userinfo = localStorage.getItem('userinfo')
          if (userinfo.length < 1) {
            return;
          }
          this.getBoolean(this.revocationType, false);
          if (this.data.length === 0) {
            return;
          }
          const revocation_pack = await this.get(this.APIOBJ.backPacking, {
            id: this.$store.state.FGid,
            username: "username",
          });
          Toast("撤销装箱成功");
          this.$store.commit("getType", "true");
          this.getBoolean(this.revocationType, true);
          this.$store.commit("getisHttp", true); //撤销之后可以装箱
          this.$emit("refresh");

        })
        .catch(() => { return; })
    },
  },
};
</script>

<style lang="less">
.filling-goods-bottom {
  display: flex;
  position: absolute;
  bottom: 0;
  width: 100%;
  margin-left: -10px;
}
</style>